module.exports = __webpack_public_path__ + "static/media/titleRight.5a55dbd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/titleRight.svg
// module id = 743
// module chunks = 0